import { h } from 'preact';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

import styles from '../../components/global.css';
import { UrlTable } from './_common.jsx';

import { LazyRpmIssueRecord } from '../../components/RpmIssueRecord/LazyRpmIssueRecord.jsx';

function LazyIssueList(_props) {
  return (
    <Card sx={{ marginBottom: '20px' }}>
      <CardActions>
        <Typography variant="h5">Latest issues</Typography>
        <Skeleton sx={{ marginLeft: 'auto' }} height={48} width={372} />
      </CardActions>
      <CardContent className={styles.goodUxHolder}>
        <UrlTable>
          {Array(30)
            .fill(null)
            .map((_, index) => (
              <LazyRpmIssueRecord key={index} />
            ))}
        </UrlTable>
      </CardContent>
      <CardActions></CardActions>
    </Card>
  );
}

export default LazyIssueList;
